<template>
  <a-modal
    v-model:visible="visible"
    :width="500"
    simple
    unmount-on-close
    :footer="true"
    :closable="true"
  >
    <template #title>
      <div class="invite-success-title">
        <icon-check-circle :size="20" style="color: #00b42a" />
        <span>{{ t('workspaceSettings.members.invitationSent') }}</span>
      </div>
    </template>
    <div class="invite-success-content">
      <p>{{ t('workspaceSettings.members.invitationSentMessage') }}</p>
    </div>
    <template #footer>
      <div class="invite-success-footer">
        <a-button @click="handleBackToSettings">
          {{ t('workspaceSettings.members.backToSettings') }}
        </a-button>
        <a-button type="primary" @click="handleInviteAnother">
          {{ t('workspaceSettings.members.inviteAnother') }}
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { IconCheckCircle } from '@arco-design/web-vue/es/icon';

  const { t } = useI18n();

  const props = defineProps<{
    modelValue: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
    (e: 'back'): void;
    (e: 'invite-another'): void;
  }>();

  const visible = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
  });

  const handleBackToSettings = () => {
    visible.value = false;
    emit('back');
  };

  const handleInviteAnother = () => {
    visible.value = false;
    emit('invite-another');
  };
</script>

<script lang="ts">
  export default {
    name: 'InviteSuccessModal',
  };
</script>

<style lang="less" scoped>
  .invite-success-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 600;
  }

  .invite-success-content {
    padding: 20px 0;
    text-align: center;

    p {
      margin: 0;
      font-size: 14px;
      color: var(--color-text-2);
      line-height: 1.6;
    }
  }

  .invite-success-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
  }
</style>
